import { takeLatest, put } from 'redux-saga/effects';
import {
  SET_MESSAGE_HOT,
  GET_MESSAGE_HOT,
  DELETE_MESSAGE_HOT,
  UPDATE_MESSAGE_HOT,
  GET_MESSAGE_LIST,
  SET_MESSAGE_COMMENT_LIST,
  SET_MESSAGE_COLLECT_LIST,
  SET_MESSAGE_SYS_LIST,
  SET_MESSAGE_COLLECT_LOADING,
  SET_MESSAGE_COMMENT_LOADING,
  SET_MESSAGE_SYS_LOADING,
  UPDATE_MESSAGE_LIST,
  SET_MESSAGE_ZAN,
  SET_MESSAGE_INVITE_LOADING,
  SET_MESSAGE_INVITE_LIST,
} from '../constants/message';
import { createAxios } from '../utils/utils';
import {
  MESSAGE_HOT_74,
  MESSAGE_HOT_DELETE_74,
  MESSAGE_LIST_74,
  FORUM_COMMENT_ZAN_72,
  INVITE_LIST_75,
} from '../config';
import { logNative } from '../utils/utils';
import Toast from '../components/Toast/Toast';

// 获取小红点状态
function* fetchMessageHot({ params }) {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(MESSAGE_HOT_74, params);
    if (res && res.data && res.data.status === 0) {
      yield put({
        type: SET_MESSAGE_HOT,
        payload: res.data.data && res.data.data.codeMap,
      });
    } else {
      yield put({
        type: SET_MESSAGE_HOT,
        payload: {},
      });
    }
  } catch (error) {
    yield put({
      type: SET_MESSAGE_HOT,
      payload: {},
    });
    logNative(`logging error${error}`, error);
  }
}
export function* watchFetchMessageHot() {
  yield takeLatest(GET_MESSAGE_HOT, fetchMessageHot);
}

// 删除小红点状态
function* fetchDeleteMessageHot({ params }) {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(MESSAGE_HOT_DELETE_74, { params });
    if (res && res.data && res.data.status === 0) {
      yield put({
        type: UPDATE_MESSAGE_HOT,
        payload: params,
      });
    }
  } catch (error) {
    logNative(`logging error${error}`, error);
  }
}
export function* watchFetchDeleteMessageHot() {
  yield takeLatest(DELETE_MESSAGE_HOT, fetchDeleteMessageHot);
}

// 获取消息列表
// 删除小红点状态
function* fetchMessageList({ params }) {
  if (params.code === 4) {
    // code 4：邀请回答
    yield put({
      type: SET_MESSAGE_INVITE_LOADING,
      payload: true,
    });
    try {
      const axios = yield createAxios('isNeedUser');
      const res = yield axios.get(INVITE_LIST_75, { params });
      if (res && res.data && res.data.status === 0) {
        yield put({
          type: SET_MESSAGE_INVITE_LIST,
          payload: {
            list: res.data.data.forumContentList,
            params,
          },
        });
      }
    } catch (error) {
      logNative(`logging error${error}`, error);
    }
    yield put({
      type: SET_MESSAGE_INVITE_LOADING,
      payload: false,
    });
  } else {
    const loading = {
      1: SET_MESSAGE_COMMENT_LOADING,
      2: SET_MESSAGE_COLLECT_LOADING,
      5: SET_MESSAGE_SYS_LOADING,
    };
    yield put({
      type: loading[params.code],
      payload: true,
    });
    try {
      const axios = yield createAxios('isNeedUser');
      const res = yield axios.get(MESSAGE_LIST_74, { params });
      if (res && res.data && res.data.status === 0) {
        // code 1:评论 2：点赞
        const type = {
          1: SET_MESSAGE_COMMENT_LIST,
          2: SET_MESSAGE_COLLECT_LIST,
          5: SET_MESSAGE_SYS_LIST,
        };
        yield put({
          type: type[params.code],
          payload: {
            list: res.data.data,
            params,
          },
        });
      }
    } catch (error) {
      logNative(`logging error${error}`, error);
    }
    yield put({
      type: loading[params.code],
      payload: false,
    });
  }
}
export function* watchFetchMessageList() {
  yield takeLatest(GET_MESSAGE_LIST, fetchMessageList);
}

// 点赞消息
function* fetchMessageZan({ params }) {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.post(FORUM_COMMENT_ZAN_72, params);

    if (res.data.status === 0 && res.data.data) {
      yield put({
        type: UPDATE_MESSAGE_LIST,
        payload: {
          // data: res.data.data,
          ...params,
        },
      });
      Toast.success({
        content: '点赞成功',
      });
    } else {
      Toast.error({ content: res.data.message || '点赞失败' });
    }
  } catch (error) {
    Toast.error({
      content: '点赞失败',
    });
  }
}
export function* watchMessageZan() {
  yield takeLatest(SET_MESSAGE_ZAN, fetchMessageZan);
}
